module.exports = "https://s91588.cdn.ngenix.net/news-frontend/_next/static/images/news-31ff5748cd7cc42f09bdd19f4e87f2e9.jpg";